import { render, staticRenderFns } from "./LatestUnits.vue?vue&type=template&id=0b16b57a&scoped=true&"
import script from "./LatestUnits.vue?vue&type=script&lang=js&"
export * from "./LatestUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16b57a",
  null
  
)

export default component.exports